// The standardized filter wire format: a param holds one { op, value } object,
// or an array of them when a field carries several clauses. Mirrors the
// backend's `is_envelope` / `parse_envelope` so a legacy reader can stand aside
// for a key that now also carries an envelope, without parsing it twice.

import { isPlainObject } from "lodash";

const safeJsonParse = raw => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const isEnvelopeParam = raw =>
  typeof raw === "string" && /^\s*[[{]/.test(raw);

export const readEnvelope = raw => {
  if (!isEnvelopeParam(raw)) return null;
  const parsed = safeJsonParse(raw);
  if (parsed == null) return null;
  const clauses = Array.isArray(parsed) ? parsed : [parsed];
  return clauses.every(c => c && typeof c === "object" && "op" in c)
    ? clauses
    : null;
};

// The envelope carries operands in `value`; the shape DEV-2574 shipped for
// custom fields used `from` / `to`.
export const operandsOf = clause =>
  "value" in clause
    ? Array.isArray(clause.value)
      ? clause.value
      : [clause.value]
    : [clause.from, clause.to].filter(v => v !== undefined);

// A date or range filter needs no reverse mapping on its way to the export:
// the export runs the same table class over the same params, so forwarding the
// envelope verbatim reproduces exactly what the grid showed. The wrapper marks
// the value as already-serialized so the export's per-type branches stand aside.
const WIRE_PARAM = "__wire";

export const wireParam = raw => ({ [WIRE_PARAM]: raw });

export const wireParamValue = param =>
  isPlainObject(param) && WIRE_PARAM in param ? param[WIRE_PARAM] : null;
